module.exports = __webpack_public_path__ + "static/media/pre.37205475.jpg";